export default __webpack_public_path__ + "static/media/medicare-card-partab-new.aaf32711.png";